import {isNotNil} from 'ramda';

import {getAllFeatureFlags} from './getAllFeatureFlags';

let isDev = false;
try {
  isDev = process.env.ENV_TYPE === 'dev';
} catch {}

// E2E tests run against review/staging builds where ENV_TYPE is not 'dev',
// so the mock must also be honored when the app runs inside Cypress.
const isRunningInCypress = () => typeof window !== 'undefined' && 'Cypress' in window;

export const isFeatureEnabled = (featureName: string) => {
  const flags = getAllFeatureFlags();

  const mockedFlags = localStorage.getItem('featureFlagMock');
  const isMockingFlagsmithFlags = (isDev || isRunningInCypress()) && isNotNil(mockedFlags);

  if (!flags) {
    return false;
  }

  if (isMockingFlagsmithFlags) {
    try {
      const parsedMockedFlags = JSON.parse(mockedFlags) as Record<string, {enabled: boolean}>;
      return parsedMockedFlags?.[featureName]?.enabled ?? flags?.[featureName]?.enabled ?? false;
    } catch (error) {
      console.warn('Error parsing mocked flags', error);
      return flags?.[featureName]?.enabled ?? false;
    }
  }

  return flags?.[featureName]?.enabled ?? false;
};
